import React from 'react';

import ModalButtons from 'components/ModalButtons';
import { SWarningText, SWarningContainer } from './styled';

type Props = {
  warningText: string;
  onCancel?: () => void;
  primaryButton: React.ComponentProps<typeof ModalButtons>['primary'];
};

const WarningModalContent = ({
  warningText,
  onCancel,
  primaryButton,
}: Props) => (
  <SWarningContainer data-test="version-control-modal-error-message">
    <div>
      <SWarningText>Warning: </SWarningText>
      {warningText}
    </div>
    <ModalButtons
      primary={primaryButton}
      secondary={onCancel && { text: 'Cancel', onClick: onCancel }}
    />
  </SWarningContainer>
);

export default WarningModalContent;
